import React, { useState, useEffect } from 'react'
import pathname from '../../constants/pathname'
import TableAllProject from '../tableAllProject/TableAllProject'
import { useHistory } from 'react-router-dom'
import { startLoading, doneLoading } from '../../utils/loading'
import { getContractStatusWait } from '../../redux/actions/dashboard'
import DashboradToggle from './DashboradToggle'
import TableLoadingTemplate from '../loadingTemplate/tableLoadingTemplate/TableLoadingTemplate'

export default function ContractStatusWait({ config, onSettingChange = () => {} }) {
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)

  let history = useHistory()

  useEffect(() => {
    if (config) {
      setSchema(seetingSchema)
    } else {
      handelGetSchemaDashboard(5, 1)
    }
  }, [])

  const handelGetSchemaDashboard = async (
    pagesize,
    pagenumber,
    projectCodeSearch,
    projectNameSearch
  ) => {
    setIsLoading(true)
    // startLoading()
    try {
      const response = await getContractStatusWait(
        pagesize,
        pagenumber,
        projectCodeSearch,
        projectNameSearch
      )
      // console.log('getContractStatusWait => ', response)
      if (response) {
        response.projectStatusText = response.projectStatusText
      }

      setSchema(response)
    } catch (e) {
      setError({})
    }
    // doneLoading()
    setIsLoading(false)
  }

  const onMutiSubmit = (selectList) => {
    // console.log('WaitForScrutinize onSubmit', selectList)

    let idList = selectList.map((element) => {
      return element.id
    })

    sessionStorage.setItem('mutiReview', idList)
    sessionStorage.setItem('projectId', 'multi-reveiw')
    sessionStorage.setItem('param', '')
    return history.push({
      pathname: `${pathname.proposal.review.projectList}`,
      state: { selectId: idList },
    })
  }

  const onSingleSubmit = (id) => {
    sessionStorage.setItem('projectId', id)
    sessionStorage.setItem('param', '')
    // console.log('id', obj.ig)
    history.push(`${pathname.proposal.overview.overviewCoworker}`)
  }

  if (!schema) {
    return <TableLoadingTemplate />
  }

  return (
    <>
      {schema && (
        <>
          {config && (
            <DashboradToggle
              onChange={onSettingChange}
              dashboradName={config.key}
              checked={config.show}
              style={{ marginTop: 20, marginBottom: -15 }}
            />
          )}

          <TableAllProject
            schema={schema}
            subName={{ enable: true }}
            muti={{ enable: false, buttonText: `ไปยังการ${schema?.mutiButtonText || 'กลั่นกรอง'}` }}
            single={{
              enable: true,
              buttonText: schema?.buttonText || 'กลั่นกรอง',
              icon: schema?.singleIcon,
            }}
            onSingleSubmit={onSingleSubmit}
            onMutiSubmit={onMutiSubmit}
            pagination={true}
            onReload={handelGetSchemaDashboard}
            loading={isLoading}
            hiddenColStatus={true}
            searchRows={{ enable: true }}
            onSearchProject={handelGetSchemaDashboard}
            showContractNo={true}
            setting={config && true}
          />
        </>
      )}
    </>
  )
}

const seetingSchema = {
  header: 'ข้อเสนอโครงการที่รอทำสัญญา/ข้อตกลง',
  projectCodeText: 'รหัสโครงการ',
  projectNameText: 'ชื่อโครงการ',
  projectTypeText: 'ประเภทโครงการ',
  projectStatusText: 'สถานะ',
  projectEditVerText: 'แก้ไขล่าสุด',
  totalSize: 1,
  values: [
    {
      projectVersionId: 'XXX',
      code: 'XX-XXXXX',
      type: {
        icon: 'file-o',
        label: 'โครงการ',
      },
      projectName: {
        name: 'โครงการ XXX',
        statusName: 'XXX',
      },
      colorstatus: {
        code: '#B5EAD6',
        label: 'XXX',
      },
      date: 'V.1 DD/MM/YYYY HH:mm:ss',
      contractNo: 'XX-XX-XXXX',
    },
  ],
}
